import { defineMessages } from 'react-intl'

import genderMessages from 'data/genders/messages'
import languageMessages from 'data/languages/messages'
import categoriesMessages from 'data/categories/messages'

export default defineMessages({
  gender: {
    id: 'data.filters.gender',
    defaultMessage: 'Gender',
  },
  genders: {
    id: 'data.filters.genders',
    defaultMessage: 'Genders',
  },
  languages: {
    id: 'data.filters.languages',
    defaultMessage: 'Languages',
  },
  categories: {
    id: 'data.filters.categories',
    defaultMessage: 'Categories',
  },
  mediums: {
    id: 'data.filters.mediums',
    defaultMessage: 'Mediums',
  },
})

export const collections = {
  genders: genderMessages,
  languages: languageMessages,
  categories: categoriesMessages,
}
